import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Input } from '../../../../input/esm';
import { MagnifierMIcon } from '@alfalab/icons-glyph/MagnifierMIcon';

var styles = {"component":"select__component_vpn82"};
require('./index.css');

var Search = forwardRef(function (_a, ref) {
    var _b = _a.clear, clear = _b === void 0 ? true : _b, _c = _a.placeholder, placeholder = _c === void 0 ? 'Поиск' : _c, className = _a.className, _d = _a.leftAddons, leftAddons = _d === void 0 ? React.createElement(MagnifierMIcon, { color: '#86868A' }) : _d, restProps = __rest(_a, ["clear", "placeholder", "className", "leftAddons"]);
    return (React.createElement(Input, __assign({ ref: ref, className: cn(styles.component, className), placeholder: placeholder, leftAddons: leftAddons, clear: clear }, restProps)));
});

export { Search };
